/* OS EDD - Mix Bundle */
(function () {
  var ROOT_SELECTOR = '[data-os-edd-mix-bundle]';
  var CHECKOUT_REDIRECT_FLAG = '__oseddCheckoutRedirectUntil';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function loadScriptOnce(src, attrName, attrValue, cb) {
    if (document.querySelector('script[' + attrName + '="' + attrValue + '"]')) {
      cb && cb();
      return;
    }

    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.setAttribute(attrName, attrValue);
    s.onload = function () {
      cb && cb();
    };

    document.head.appendChild(s);
  }

  function osjfOrdinal(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;

    return s[(v - 20) % 10] || s[v] || s[0];
  }

  function osjfFormatDate(d) {
    var months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
    var mm = months[d.getMonth()];
    var day = d.getDate();
    var yyyy = d.getFullYear();

    return mm + ' ' + day + osjfOrdinal(day) + ' ' + yyyy;
  }

  function initOSMB_OfferDates(root) {
    if (!root) return;

    var wrap = qs(root, '[data-osmb-offer-dates]');
    if (!wrap) return;

    if (wrap.dataset.osmbDatesInit === '1') return;
    wrap.dataset.osmbDatesInit = '1';

    var restockedEl = qs(root, '[data-osmb-restocked-date]');
    var selloutEl = qs(root, '[data-osmb-sellout-date]');
    if (!restockedEl || !selloutEl) return;

    var today = new Date();
    var restocked = today;
    var sellout = new Date(today.getTime() + (7 * 24 * 60 * 60 * 1000));

    restockedEl.textContent = osjfFormatDate(restocked);
    selloutEl.textContent = osjfFormatDate(sellout);
  }

  function initOSMB_OfferLottie(root) {
    if (!root) return;

    var iconEls = qsa(root, '[data-osmb-offer-lottie]');
    if (!iconEls.length) return;

    loadScriptOnce(
      'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js',
      'data-osmb-lottie-lib',
      '1',
      function () {
        if (!window.lottie) return;

        iconEls.forEach(function (iconEl) {
          var url = iconEl.getAttribute('data-lottie-url');
          if (!url) return;

          var container = iconEl.querySelector('.osmb-offer-box__callout-lottie');
          if (!container) return;

          if (iconEl.__osmbOfferLottieAnim) {
            try {
              iconEl.__osmbOfferLottieAnim.destroy();
            } catch (e) {}

            iconEl.__osmbOfferLottieAnim = null;
          }

          container.innerHTML = '';

          iconEl.__osmbOfferLottieAnim = window.lottie.loadAnimation({
            container: container,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: url,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid meet',
              progressiveLoad: true
            }
          });
        });
      }
    );
  }

  function toInt(v, fallback) {
    var n = parseInt(String(v || ''), 10);
    return isNaN(n) ? fallback : n;
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function setCheckoutRedirectGuard(durationMs) {
    durationMs = durationMs || 6000;
    window[CHECKOUT_REDIRECT_FLAG] = Date.now() + Math.max(1000, Number(durationMs) || 6000);
  }

  function clearCheckoutRedirectGuard() {
    delete window[CHECKOUT_REDIRECT_FLAG];
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload || {}),
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (res) {
      var contentType = res.headers.get('content-type') || '';
      var isJson = contentType.indexOf('application/json') !== -1;

      return (isJson ? res.json() : res.text()).then(function (data) {
        if (!res.ok) {
          var msg =
            (data && (data.description || data.message)) ||
            (typeof data === 'string' ? data : 'Request failed');

          throw new Error(msg);
        }

        return data;
      });
    });
  }

  function parseVariantIdList(str) {
    var out = [];
    var raw = String(str || '').trim();
    if (!raw) return out;

    raw.split(/[,|\n]/g).forEach(function (part) {
      var p = String(part || '').trim();
      if (!p) return;

      var seg = p.split(':');
      var id = toInt(seg[0], 0);
      if (!id) return;

      var qty = 1;
      if (seg.length > 1) {
        qty = toInt(seg[1], 1);
        if (qty <= 0) qty = 1;
      }

      out.push({
        id: id,
        quantity: qty
      });
    });

    return out;
  }

  function parseDiscountCodes(str) {
    var raw = String(str || '').trim();
    var out = [];
    var seen = {};

    if (!raw) return out;

    raw.split(/[,|\n]/g).forEach(function (part) {
      var code = String(part || '').trim();
      var key = code.toLowerCase();

      if (!code || seen[key]) return;

      seen[key] = true;
      out.push(code);
    });

    return out;
  }

  function getSectionConfig(root) {
    return {
      bogoUrlParamsEnabled: root && root.getAttribute('data-bogo-url-params-enabled') === 'true',
      bogoUrlParams: (root && root.getAttribute('data-bogo-url-params')) || '',
      checkoutUrl: (root && root.getAttribute('data-checkout-url')) || '/checkout'
    };
  }

  function normalizeBogoParamString(rawValue) {
    if (!rawValue) return '';
    var normalized = String(rawValue).trim();
    if (!normalized) return '';

    if (normalized.indexOf('://') !== -1) {
      try {
        normalized = new URL(normalized).search.replace(/^\?/, '');
      } catch (err) {}
    }

    var queryStartIndex = normalized.indexOf('?');
    if (queryStartIndex > -1) {
      normalized = normalized.slice(queryStartIndex + 1);
    }

    normalized = normalized.replace(/^[?&]+/, '');

    var hashIndex = normalized.indexOf('#');
    if (hashIndex > -1) {
      normalized = normalized.slice(0, hashIndex);
    }

    return normalized.trim();
  }

  function applyBogoUrlParams(root, options) {
    var sectionConfig = getSectionConfig(root);
    var bogo = window.AmbrosiaBogoUrlParams;
    if (!bogo) return false;
    return bogo.apply(sectionConfig, options);
  }

  function extractBogoCartAttributes(root) {
    var sectionConfig = getSectionConfig(root);
    var raw = normalizeBogoParamString(sectionConfig.bogoUrlParams);
    if (!raw) return null;
    var attrs = {};
    var hasAny = false;
    new URLSearchParams(raw).forEach(function (value, key) {
      if (!key) return;
      attrs[key] = value;
      hasAny = true;
    });
    return hasAny ? attrs : null;
  }

  function waitForBogoGift(knownItemCount) {
    return new Promise(function (resolve) {
      var elapsed = 0;
      var interval = 200;
      var maxWait = 3000;

      function check() {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart.item_count > knownItemCount) {
              resolve(true);
            } else {
              elapsed += interval;
              if (elapsed >= maxWait) {
                resolve(false);
              } else {
                setTimeout(check, interval);
              }
            }
          })
          .catch(function () { resolve(false); });
      }

      setTimeout(check, interval);
    });
  }

  function mergeConfiguredBogoParams(checkoutUrl, root) {
    var sectionConfig = getSectionConfig(root);
    if (!sectionConfig.bogoUrlParamsEnabled) return;

    var sanitizedParams = normalizeBogoParamString(sectionConfig.bogoUrlParams);
    if (!sanitizedParams) return;

    var incomingParams = new URLSearchParams(sanitizedParams);
    incomingParams.forEach(function (value, key) {
      if (!key) return;
      checkoutUrl.searchParams.set(key, value);
    });
  }

  function getCheckoutUrlWithCurrentParams(root, discountCodes) {
    var sectionConfig = getSectionConfig(root);
    var checkoutBase = sectionConfig.checkoutUrl || '/checkout';
    var checkoutUrl = new URL(checkoutBase, window.location.origin);
    var currentParams = new URLSearchParams(window.location.search);

    currentParams.forEach(function (value, key) {
      checkoutUrl.searchParams.set(key, value);
    });

    mergeConfiguredBogoParams(checkoutUrl, root);

    if (discountCodes && discountCodes.length > 0) {
      checkoutUrl.searchParams.set('discount', discountCodes.join(','));
    }

    if (checkoutUrl.origin === window.location.origin) {
      return checkoutUrl.pathname + checkoutUrl.search + checkoutUrl.hash;
    }

    return checkoutUrl.toString();
  }

  function getDiscountCodesForTotal(total, d1, d2, d3) {
    var codes = [];

    if (total >= 1) codes = codes.concat(parseDiscountCodes(d1));
    if (total >= 2) codes = codes.concat(parseDiscountCodes(d2));
    if (total >= 3) codes = codes.concat(parseDiscountCodes(d3));

    var seen = {};
    var out = [];

    codes.forEach(function (code) {
      var key = String(code || '').toLowerCase();
      if (!key || seen[key]) return;

      seen[key] = true;
      out.push(code);
    });

    return out;
  }

  function getFreebieItemsForTotal(total, f1, f2, f3) {
    var freebies = [];

    if (total >= 1) freebies = freebies.concat(parseVariantIdList(f1));
    if (total >= 2) freebies = freebies.concat(parseVariantIdList(f2));
    if (total >= 3) freebies = freebies.concat(parseVariantIdList(f3));

    return freebies;
  }

  function mergeItems(baseItems, extraItems) {
    var map = {};
    var out = [];

    function keyOf(item) {
      var plan = item && item.selling_plan ? String(item.selling_plan) : '';
      return String(item && item.id ? item.id : '') + '::' + plan;
    }

    function addItem(item) {
      if (!item || !item.id || !item.quantity) return;

      var key = keyOf(item);

      if (!map[key]) {
        map[key] = {
          id: item.id,
          quantity: item.quantity
        };

        if (item.selling_plan) {
          map[key].selling_plan = item.selling_plan;
        }

        if (item.properties) {
          map[key].properties = item.properties;
        }

        out.push(map[key]);
      } else {
        map[key].quantity += item.quantity;
      }
    }

    (baseItems || []).forEach(addItem);
    (extraItems || []).forEach(addItem);

    return out;
  }

  function buildItemsFromState(state, planId, planMeta) {
    var items = [];
    var cleanPlanId = toInt(planId, 0);

    Object.keys(state.counts).forEach(function (variantId) {
      var qty = toInt(state.counts[variantId], 0);
      if (qty <= 0) return;

      var item = {
        id: toInt(variantId, 0),
        quantity: qty,
        properties: {
          _osmb_mix_bundle: '1'
        }
      };

      if (planMeta && planMeta.plan1) {
        item.properties._osmb_plan_1 = String(planMeta.plan1);
      }

      if (planMeta && planMeta.plan2) {
        item.properties._osmb_plan_2 = String(planMeta.plan2);
      }

      if (planMeta && planMeta.plan3) {
        item.properties._osmb_plan_3 = String(planMeta.plan3);
      }

      if (cleanPlanId) {
        item.selling_plan = cleanPlanId;
      }

      items.push(item);
    });

    return items;
  }

  function getScrollOffsetPx() {
    try {
      var header = document.querySelector('.header-wrapper');
      if (!header) return 0;

      var style = window.getComputedStyle(header);
      if (style.display === 'none' || style.visibility === 'hidden') return 0;

      var pos = (style.position || '').toLowerCase();
      if (pos !== 'fixed' && pos !== 'sticky') return 0;

      return Math.max(0, Math.round(header.getBoundingClientRect().height || 0));
    } catch (e) {
      return 0;
    }
  }

  function smoothScrollToTarget(targetEl) {
    if (!targetEl) return;

    var offset = getScrollOffsetPx();
    var rect = targetEl.getBoundingClientRect();
    var y = Math.round(window.pageYOffset + rect.top - offset - 12);

    window.scrollTo({
      top: Math.max(0, y),
      behavior: 'smooth'
    });
  }

  function setStickyVisible(root, isVisible) {
    var sticky = qs(root, '[data-osedd-sticky]');
    if (!sticky) return;

    if (isVisible) {
      root.classList.add('osedd-sticky-active');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      root.classList.remove('osedd-sticky-active');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  function bindStickyObserver(root, mainCta) {
    if (!root || !mainCta || root.__osmbStickyObserved) return;

    root.__osmbStickyObserved = true;

    var revealedCta = qs(root, '[data-osjf-cta]');
    var targets = [mainCta];
    if (revealedCta) targets.push(revealedCta);

    var inViewMap = {};
    var scrolledPastMap = {};
    targets.forEach(function (el, i) {
      inViewMap[i] = false;
      scrolledPastMap[i] = false;
    });

    function updateSticky() {
      var anyInView = false;
      var anyScrolledPast = false;
      targets.forEach(function (el, i) {
        if (inViewMap[i]) anyInView = true;
        if (scrolledPastMap[i]) anyScrolledPast = true;
      });
      // Show sticky only after at least one CTA has been scrolled past (is above viewport)
      // and no CTA is currently on screen
      setStickyVisible(root, !anyInView && anyScrolledPast);
    }

    if (!('IntersectionObserver' in window)) {
      var onScroll = function () {
        targets.forEach(function (el, i) {
          var r = el.getBoundingClientRect();
          inViewMap[i] = r.bottom > 0 && r.top < window.innerHeight;
          scrolledPastMap[i] = r.bottom < 0;
        });
        updateSticky();
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();

      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var i = targets.indexOf(entry.target);
          if (i === -1) return;
          inViewMap[i] = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          scrolledPastMap[i] = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        });
        updateSticky();
      },
      {
        root: null,
        threshold: [0, 0.25, 0.5, 1]
      }
    );

    targets.forEach(function (el) { obs.observe(el); });
    root.__osmbStickyObs = obs;
  }

  function bindInfoDropdowns(root) {
    var items = qsa(root, '.osedd-topshop__infoItem');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = qs(item, '[data-osedd-info-btn]') || qs(item, '[data-osmb-info-btn]');
      var panel = qs(item, '[data-osedd-info-panel]') || qs(item, '[data-osmb-info-panel]');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (sib) {
          if (sib === item) return;

          sib.classList.remove('is-open');

          var sibBtn = qs(sib, '[data-osedd-info-btn]') || qs(sib, '[data-osmb-info-btn]');
          var sibPanel = qs(sib, '[data-osedd-info-panel]') || qs(sib, '[data-osmb-info-panel]');

          if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
          if (sibPanel) sibPanel.hidden = true;
        });

        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function bindRteScrollLinks(root) {
    var containers = qsa(
      root,
      '.osedd-topshop__awardBody.rte, .osedd-topshop__offerBody.rte, .osedd-topshop__awardBodyImgRight.rte'
    );

    if (!containers.length) return;

    containers.forEach(function (wrap) {
      wrap.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a') : null;
        if (!a) return;

        var href = (a.getAttribute('href') || '').trim();
        if (!href || href === '#' || href.charAt(0) !== '#') return;

        var id = href.slice(1);
        if (!id) return;

        var target = document.getElementById(id);
        if (!target) return;

        e.preventDefault();
        smoothScrollToTarget(target);

        try {
          history.pushState(null, '', '#' + id);
        } catch (err) {}
      });
    });
  }

  function openForm(root) {
    var offerView = qs(root, '[data-osmb-offer-view]');
    var formView = qs(root, '[data-osmb-form-view]');
    var card = qs(root, '[data-osmb-offer-card]');

    if (!offerView || !formView) return;

    root.classList.add('is-form-open');

    offerView.hidden = true;
    formView.hidden = false;

    updateRefillNote();

    window.setTimeout(function () {
      smoothScrollToTarget(card || formView);

      var firstPlus = qs(root, '[data-osjf-plus]');
      if (firstPlus) firstPlus.focus({ preventScroll: true });
    }, 50);
  }

  function closeForm(root) {
    var offerView = qs(root, '[data-osmb-offer-view]');
    var formView = qs(root, '[data-osmb-form-view]');
    var mainCta = qs(root, '[data-osmb-open-form]:not([data-osedd-sticky-cta])');

    if (!offerView || !formView) return;

    root.classList.remove('is-form-open');

    offerView.hidden = false;
    formView.hidden = true;

    window.setTimeout(function () {
      smoothScrollToTarget(qs(root, '[data-osmb-offer-card]') || offerView);

      if (mainCta) mainCta.focus({ preventScroll: true });
    }, 50);
  }

  function initGallery(root) {
    var gallery = qs(root, '[data-osedd-gallery]');
    var mainSlides = qsa(root, '[data-osedd-gal-main-slide]');
    var thumbs = qsa(root, '[data-osedd-thumb]');
    var thumbViewport = qs(root, '[data-osedd-thumb-viewport]');
    var mainPrev = qs(root, '[data-osedd-main-nav="prev"]');
    var mainNext = qs(root, '[data-osedd-main-nav="next"]');

    if (qs(root, '.osedd-topshop__galThumbs')) {
      root.classList.add('osedd-has-thumbs');
    } else {
      root.classList.remove('osedd-has-thumbs');
    }

    if (!gallery || !mainSlides.length) return;

    var index = 0;

    function syncMainNav() {
      if (!mainPrev || !mainNext) return;

      var max = Math.max(0, mainSlides.length - 1);
      mainPrev.disabled = index <= 0;
      mainNext.disabled = index >= max;
    }

    function setActive(nextIndex) {
      var max = Math.max(0, mainSlides.length - 1);
      index = Math.min(Math.max(nextIndex, 0), max);

      mainSlides.forEach(function (slide, i) {
        var isActive = i === index;

        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (isActive) {
          slide.setAttribute('data-osedd-active', '1');
        } else {
          slide.removeAttribute('data-osedd-active');
        }
      });

      thumbs.forEach(function (thumb, i) {
        var isActive = i === index;

        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');

        if (isActive) {
          thumb.setAttribute('data-osedd-active', '1');
        } else {
          thumb.removeAttribute('data-osedd-active');
        }
      });

      var activeThumb = thumbs[index];
      if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
        activeThumb.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }

      syncMainNav();
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = Number(thumb.getAttribute('data-osedd-gal-index') || 0);
        setActive(i);
      });
    });

    if (mainPrev) {
      mainPrev.addEventListener('click', function (e) {
        e.preventDefault();
        setActive(index - 1);
      });
    }

    if (mainNext) {
      mainNext.addEventListener('click', function (e) {
        e.preventDefault();
        setActive(index + 1);
      });
    }

    if (thumbViewport) {
      thumbViewport.style.scrollBehavior = 'smooth';
    }

    syncMainNav();
  }

  function initFlavorForm(root) {
    if (!root || root.__osmbFlavorInit) return;
    root.__osmbFlavorInit = true;

    var required = toInt(root.getAttribute('data-default-required'), 1);
    var maxQty = toInt(root.getAttribute('data-max-qty'), 3);
    var planMode = String(root.getAttribute('data-plan-mode') || 'subscription').toLowerCase();
    var isOtp = planMode === 'otp' || planMode === 'one-time' || planMode === 'onetime';

    var plan1 = root.getAttribute('data-plan-1') || '';
    var plan2 = root.getAttribute('data-plan-2') || '';
    var plan3 = root.getAttribute('data-plan-3') || '';

    var freebies1 = root.getAttribute('data-freebies-1') || '';
    var freebies2 = root.getAttribute('data-freebies-2') || '';
    var freebies3 = root.getAttribute('data-freebies-3') || '';

    var disc1 = root.getAttribute('data-discount-1') || '';
    var disc2 = root.getAttribute('data-discount-2') || '';
    var disc3 = root.getAttribute('data-discount-3') || '';

    var clearCart = (root.getAttribute('data-clear-cart') || 'true') === 'true';
    var baseCTAPrice = parseFloat(String(root.getAttribute('data-base-cta-price') || '').replace(/[^0-9.]/g, '')) || 0;
    var baseCTAComparePrice = parseFloat(String(root.getAttribute('data-base-compare-price') || '').replace(/[^0-9.]/g, '')) || 0;
    var baseCTAComparePrice2 = parseFloat(String(root.getAttribute('data-base-compare-price-2') || '').replace(/[^0-9.]/g, '')) || 0;
    var baseRecurringPrice = parseFloat(String(root.getAttribute('data-base-recurring-price') || '').replace(/[^0-9.]/g, '')) || 0;
    var baseSubSchedule = String(root.getAttribute('data-base-sub-schedule') || '').trim();

    var titleEl = qs(root, '[data-osjf-title]');
    var subEl = qs(root, '[data-osjf-sub]');
    var noteEl = qs(root, '[data-osjf-note]');
    var errorEl = qs(root, '[data-osjf-error]');
    var ctaBtn = qs(root, '[data-osjf-cta]');
    var ctaLeft = qs(root, '[data-osjf-cta-left]');
    var refillNoteEl = qs(root, '[data-osmb-refill-note]');
    var progressTextEl = qs(root, '[data-osjf-progress-text]');
    var barFillEl = qs(root, '[data-osjf-bar-fill]');
    var backBtn = qs(root, '[data-osjf-back]');
    var itemEls = qsa(root, '[data-osjf-item]');

    var readyText = 'Proceed to Checkout';
    var readyTextSetting = root.querySelector('[data-osjf-cta-left]');
    if (readyTextSetting && readyTextSetting.dataset.readyText) {
      readyText = readyTextSetting.dataset.readyText;
    }

    var state = {
      required: Math.max(1, required),
      max: Math.max(required, maxQty),
      counts: {},
      total: 0
    };

    function getSellingPlanIdForQty(qty) {
      if (isOtp) return '';

      var cleanQty = toInt(qty, 0);

      if (cleanQty <= 1) {
        return plan1 || '';
      }

      if (cleanQty === 2) {
        return plan2 || plan1 || '';
      }

      return plan3 || '';
    }

    function getSellingPlanMeta() {
      if (isOtp) {
        return {
          plan1: '',
          plan2: '',
          plan3: ''
        };
      }

      return {
        plan1: plan1 || '',
        plan2: plan2 || '',
        plan3: plan3 || ''
      };
    }

    function recalcTotal() {
      var total = 0;

      Object.keys(state.counts).forEach(function (variantId) {
        total += toInt(state.counts[variantId], 0);
      });

      state.total = total;
    }

    function setHeader() {
      if (titleEl) {
        titleEl.textContent =
          root.getAttribute('data-form-heading') || 'BUY MORE, SAVE MORE → ADD 2 OR MORE';
      }

      if (subEl) {
        subEl.textContent = isOtp
          ? 'Try it once. Pick your flavors.'
          : 'Subscribe & save. Pick your flavors.';
      }

      if (noteEl) {
        noteEl.textContent = isOtp
          ? 'No autoship. You can check out once you’ve selected ' + state.required + ' bag' + (state.required === 1 ? '.' : 's.')
          : 'Subscription will be applied at checkout.';
      }
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function normalizeCtaQty(total) {
      if (total <= 1) return 1;
      if (total === 2) return 2;
      return 3;
    }

    function formatPrice(n) {
      return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
    }

    function getCtaPriceData(total) {
      var cleanTotal = toInt(total, 0);

      if (cleanTotal >= 4 && baseCTAPrice > 0) {
        var computedPrice = baseCTAPrice * cleanTotal;
        var computedCompare = 0;
        if (baseCTAComparePrice > 0) {
          computedCompare = baseCTAComparePrice + (baseCTAComparePrice2 > 0 ? baseCTAComparePrice2 * (cleanTotal - 3) : 0);
        }
        var perBottleStr = formatPrice(baseCTAPrice) + ' per bottle';

        return {
          prefix: root.getAttribute('data-cta-price-prefix') || 'TRY ONE SOL TODAY',
          compare: computedCompare > 0 ? formatPrice(computedCompare) : '',
          price: formatPrice(computedPrice),
          perBottle: perBottleStr,
          computed: false
        };
      }

      var qty = normalizeCtaQty(cleanTotal);

      return {
        prefix: root.getAttribute('data-cta-price-prefix') || 'TRY ONE SOL TODAY',
        compare: root.getAttribute('data-cta-compare-' + qty) || '',
        price: root.getAttribute('data-cta-price-' + qty) || '',
        perBottle: root.getAttribute('data-cta-per-bottle-' + qty) || '',
        computed: false
      };
    }

    function renderPerBottleHtml(perBottleText) {
      var cleanText = String(perBottleText || '').trim();
      if (!cleanText) return '';

      var raw = escapeHtml(cleanText);
      var value = raw;
      var label = '';
      var lower = raw.toLowerCase();
      var perIndex = lower.indexOf(' per ');

      if (perIndex >= 0) {
        value = raw.slice(0, perIndex);
        label = raw.slice(perIndex + 1).trim();
      }

      var match = value.match(/^(\$?\d+)\.(\d{2})$/);
      if (match) {
        value = match[1] + '<sup>' + match[2] + '</sup>';
      }

      return (
        '<span class="osjf-cta-offer__perBottle">' +
          '<span class="osjf-cta-offer__perBottleValue">' + value + '</span>' +
          (label ? '<span class="osjf-cta-offer__perBottleLabel">' + label + '</span>' : '') +
        '</span>'
      );
    }

    function renderCtaOfferHtml(total) {
      var data = getCtaPriceData(total);

      return (
        '<span class="osjf-cta-offer">' +
          '<span class="osjf-cta-offer__prefix">' + escapeHtml(data.prefix) + '</span>' +
          '<span class="osjf-cta-offer__arrow" aria-hidden="true">→</span>' +
          (data.compare ? '<span class="osjf-cta-offer__compare">' + escapeHtml(data.compare) + '</span>' : '') +
          (data.price ? '<span class="osjf-cta-offer__price">' + escapeHtml(data.price) + '</span>' : '') +
          renderPerBottleHtml(data.perBottle) +
        '</span>'
      );
    }

    function getRefillNoteText(total) {
      var cleanTotal = toInt(total, 0);

      if (cleanTotal <= 0) {
        return '';
      }

      if (cleanTotal >= 4 && baseRecurringPrice > 0) {
        var computedRecurring = baseRecurringPrice * cleanTotal;
        var formattedRecurring = '$' + computedRecurring.toFixed(2);
        var schedule = baseSubSchedule || 'every 30 days';
        return 'Then ' + formattedRecurring + ' refills ' + schedule + '.';
      }

      var qty = normalizeCtaQty(cleanTotal);
      var note = root.getAttribute('data-refill-note-' + qty) || '';

      if (!note && qty === 3) {
        note = root.getAttribute('data-refill-note-2') || root.getAttribute('data-refill-note-1') || '';
      }

      if (!note && qty === 2) {
        note = root.getAttribute('data-refill-note-1') || '';
      }

      return String(note || '').trim();
    }

    function updateRefillNote() {
      if (!refillNoteEl) return;

      var noteText = getRefillNoteText(state.total);

      if (!noteText) {
        noteText = root.getAttribute('data-refill-note-1') || '';
      }

      refillNoteEl.textContent = noteText;

      if (!root.classList.contains('is-form-open')) {
        refillNoteEl.hidden = true;
        refillNoteEl.style.display = 'none';
        return;
      }

      refillNoteEl.hidden = false;
      refillNoteEl.removeAttribute('hidden');
      refillNoteEl.style.display = '';
    }

    function updateUI() {
      recalcTotal();

      itemEls.forEach(function (row) {
        if (row.getAttribute('data-sold-out') === '1') return;

        var vid = row.getAttribute('data-variant-id');
        var qtyEl = qs(row, '[data-osjf-row-qty]');
        var minusBtn = qs(row, '[data-osjf-minus]');
        var plusBtn = qs(row, '[data-osjf-plus]');
        var qty = toInt(state.counts[vid], 0);

        if (qtyEl) qtyEl.textContent = String(qty);
        if (minusBtn) minusBtn.disabled = qty <= 0;
        if (plusBtn) plusBtn.disabled = state.total >= state.max;
      });

      var pct = state.max > 0 ? Math.min(100, Math.round((state.total / state.max) * 100)) : 0;

      if (barFillEl) {
        barFillEl.style.width = pct + '%';
      }

      if (progressTextEl) {
        progressTextEl.textContent = state.total + '/' + state.max + ' selected';
      }

      updateRefillNote();

      if (errorEl && state.total > 0) {
        errorEl.textContent = '';
      }

      var canCheckout = state.total >= state.required;
      var idleText = '';

      if (ctaLeft) {
        idleText =
          ctaLeft.getAttribute('data-idle-text') ||
          root.getAttribute('data-form-cta-idle') ||
          'CHOOSE YOUR FLAVOR';
      }

      if (ctaBtn) {
        ctaBtn.disabled = false;
        ctaBtn.classList.toggle('has-selection', state.total > 0);
        ctaBtn.classList.toggle('is-ready', canCheckout);
        ctaBtn.classList.toggle('is-idle', state.total <= 0);

        if (ctaLeft) {
          if (state.total <= 0) {
            ctaLeft.textContent = idleText;
          } else {
            ctaLeft.innerHTML = renderCtaOfferHtml(state.total);
          }
        }
      }
    }

    function setBusy(isBusy) {
      if (!ctaBtn) return;

      ctaBtn.disabled = !!isBusy;
      ctaBtn.setAttribute('aria-busy', isBusy ? 'true' : 'false');

      if (isBusy) {
        ctaBtn.classList.add('is-busy');
        if (ctaLeft) {
          ctaLeft.innerHTML =
            '<span class="osjf-cta-spinner" aria-hidden="true">' +
              '<svg class="osjf-cta-spinner-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">' +
                '<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="40" stroke-dashoffset="10" stroke-linecap="round"/>' +
              '</svg>' +
            '</span>';
        }
      } else {
        ctaBtn.classList.remove('is-busy');
      }
    }

    itemEls.forEach(function (row) {
      var vid = row.getAttribute('data-variant-id');
      var minusBtn = qs(row, '[data-osjf-minus]');
      var plusBtn = qs(row, '[data-osjf-plus]');
      var isSoldOut = row.getAttribute('data-sold-out') === '1';

      if (!vid || isSoldOut) return;

      state.counts[vid] = 0;

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var current = toInt(state.counts[vid], 0);
          state.counts[vid] = Math.max(0, current - 1);
          updateUI();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          if (state.total >= state.max) return;

          var current = toInt(state.counts[vid], 0);
          state.counts[vid] = current + 1;
          updateUI();
        });
      }
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        closeForm(root);
      });
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        if (root.__osmbSubmitting) return;

        recalcTotal();

        if (state.total < state.required) {
          updateUI();

          if (errorEl) {
            errorEl.textContent = 'Please choose at least 1 flavor.';
          }

          var firstPlusBtn = qs(root, '[data-osjf-plus]');
          if (firstPlusBtn) {
            firstPlusBtn.focus({ preventScroll: true });
          }

          return;
        }

        root.__osmbSubmitting = true;
        setBusy(true);
        setCheckoutRedirectGuard();

        if (errorEl) errorEl.textContent = '';

        applyBogoUrlParams(root);

        var selectedPlanId = getSellingPlanIdForQty(state.total);
        var selectedPlanMeta = getSellingPlanMeta();
        var baseItems = buildItemsFromState(state, selectedPlanId, selectedPlanMeta);
        var freebieItems = getFreebieItemsForTotal(state.total, freebies1, freebies2, freebies3);
        var items = mergeItems(baseItems, freebieItems);

        var codes = getDiscountCodesForTotal(state.total, disc1, disc2, disc3);

        Promise.resolve()
          .then(function () {
            if (clearCart) {
              return postJSON('/cart/clear.js', {}).then(function () {
                return wait(180);
              });
            }
          })
          .then(function () {
            return postJSON('/cart/add.js', {
              items: items
            });
          })
          .then(function (addResult) {
            var bogoAttrs = extractBogoCartAttributes(root);
            if (!bogoAttrs) return addResult;
            var itemCountAfterAdd = (addResult && typeof addResult.item_count === 'number')
              ? addResult.item_count
              : 1;
            return postJSON('/cart/update.js', { attributes: bogoAttrs })
              .then(function (updatedCart) {
                var countNow = (updatedCart && typeof updatedCart.item_count === 'number')
                  ? updatedCart.item_count
                  : itemCountAfterAdd;
                return waitForBogoGift(countNow);
              });
          })
          .then(function () {
            applyBogoUrlParams(root);
            window.location.href = getCheckoutUrlWithCurrentParams(root, codes);
          })
          .catch(function (err) {
            var msg = err && err.message ? err.message : 'Unable to start checkout. Please try again.';

            if (errorEl) {
              errorEl.textContent = msg;
            }

            root.__osmbSubmitting = false;
            setBusy(false);
            updateUI();
            clearCheckoutRedirectGuard();
          });
      });
    }

    setHeader();
    updateUI();
  }

  function bindRoot(root) {
    if (!root || root.__osmbBound) return;
    root.__osmbBound = true;

    if (applyBogoUrlParams(root, { allowReload: true })) return;

    var mainOpenButtons = qsa(root, '[data-osmb-open-form]');

    mainOpenButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isStickyBtn = btn.hasAttribute('data-osedd-sticky-cta');
        if (isStickyBtn && root.classList.contains('is-form-open')) {
          var card = qs(root, '[data-osmb-offer-card]');
          smoothScrollToTarget(card || qs(root, '[data-osmb-form-view]'));
          return;
        }
        openForm(root);
      });
    });

    var mainCta = qs(root, '[data-osmb-open-form]:not([data-osedd-sticky-cta])');

    if (mainCta) {
      bindStickyObserver(root, mainCta);
    }

    bindInfoDropdowns(root);
    bindRteScrollLinks(root);
    initGallery(root);
    initFlavorForm(root);
    initOSMB_OfferLottie(root);
    initOSMB_OfferDates(root);
  }

  function initAll() {
    qsa(document, ROOT_SELECTOR).forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;

    qsa(section, ROOT_SELECTOR).forEach(bindRoot);
  });
})();